// PROTOTYPE ONLY. Routes below exist so screens can be previewed individually.
// The production borrower experience is a single LWC shell on one secure ?t= URL;
// screen changes are internal state, not navigation. React, routing, Tailwind and
// Framer Motion are not part of the implementation — tokens, layout, transitions
// and interactions are the specification.
import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { PortalProvider } from './contexts/PortalContext';
import { Welcome } from './pages/Welcome';
import { Application } from './pages/Application';
import { Credit } from './pages/Credit';
import { LoanOptions } from './pages/LoanOptions';
import { SubmitApplication } from './pages/SubmitApplication';
import { Complete } from './pages/Complete';
import { Documents } from './pages/Documents';
import { Dashboard } from './pages/Dashboard';
import { TaskDetail } from './pages/TaskDetail';
import { Messages } from './pages/Messages';
import { Updates } from './pages/Updates';
type EntryScreen = 'welcome' | 'application' | 'review' | 'credit' | 'loanOptions' | 'documents' | 'dashboard' | 'processorRequest';
type BorrowerScenario = 'underContract' | 'shopping' | 'refinance';
type RateStatus = 'selected' | 'confirmed' | 'floating' | 'locked';
interface AppProps {
  entryScreen?: EntryScreen;
  borrowerScenario?: BorrowerScenario;
  rateStatus?: RateStatus;
}
const entryPaths: Record<EntryScreen, string> = {
  welcome: '/',
  application: '/apply/employer',
  review: '/apply/review',
  credit: '/credit',
  loanOptions: '/options',
  documents: '/documents',
  dashboard: '/loan',
  processorRequest: '/loan/task/chase-september'
};
export function App({
  entryScreen = 'welcome',
  borrowerScenario = 'underContract',
  rateStatus = 'selected'
}: AppProps) {
  return <PortalProvider key={`${borrowerScenario}-${rateStatus}`} scenario={borrowerScenario} initialPricingStatus={rateStatus} data-id="element-0" data-mp="nv0ybtt2yq5o">
      <BrowserRouter data-id="element-1" data-mp="swq8z8ce51t8">
        <Routes data-id="element-2" data-mp="3684vetzoctf">
          <Route path="/" element={entryScreen === 'welcome' ? <Welcome data-id="element-4" data-mp="38kv0f9whthk" /> : <Navigate to={entryPaths[entryScreen]} replace data-id="element-5" data-mp="38b2ol1dva8p" />} data-id="element-3" data-mp="35ozexlizgwa" />
          <Route path="/welcome" element={<Welcome data-id="element-7" data-mp="3uf5gzkl3mb7q" />} data-id="element-6" data-mp="3uc9k7zkzlskv" />
          <Route path="/apply" element={<Navigate to="/apply/goal" replace data-id="element-9" data-mp="d3cujon1mqez" />} data-id="element-8" data-mp="d57g95652mk4" />
          <Route path="/apply/:stepId" element={<Application data-id="element-11" data-mp="86mfn4mz60v5" />} data-id="element-10" data-mp="85l30vqb96bb" />
          <Route path="/credit" element={<Credit data-id="element-13" data-mp="3gle8mfj3sxdl" />} data-id="element-12" data-mp="86cnbaegjhma" />
          <Route path="/options" element={<LoanOptions data-id="element-15" data-mp="3gm61vjp8aj0p" />} data-id="element-14" data-mp="3gkv1ltuzrtec" />
          <Route path="/submit" element={<SubmitApplication data-id="element-17" data-mp="3bmtixa1h9w3e" />} data-id="element-16" data-mp="3gja2rs1n9oao" />
          <Route path="/complete" element={<Complete data-id="element-19" data-mp="3bk736n4foaa3" />} data-id="element-18" data-mp="3bnmerfywf16r" />
          <Route path="/documents" element={<Documents data-id="element-21" data-mp="3qbzfsrcufa84" />} data-id="element-20" data-mp="3qaxttruah3bm" />
          <Route path="/loan" element={<Dashboard data-id="element-23" data-mp="3lkhfm5in9do7" />} data-id="element-22" data-mp="3qcipjkscasb2" />
          <Route path="/loan/task/:taskId" element={<TaskDetail data-id="element-25" data-mp="3lj6bg4lae3wk" />} data-id="element-24" data-mp="3lk7ky4mnmic6" />
          <Route path="/loan/messages" element={<Messages data-id="element-27" data-mp="2xtv7ke8n3te7" />} data-id="element-26" data-mp="2xuwtjdr720ap" />
          <Route path="/loan/updates" element={<Updates data-id="element-29" data-mp="2svtqtzyos65w" />} data-id="element-28" data-mp="2xt287yc0g663" />
          <Route path="*" element={<Navigate to="/" replace data-id="element-31" data-mp="2sv0m14jafqqe" />} data-id="element-30" data-mp="2swlix0t2rlrf" />
        </Routes>
      </BrowserRouter>
    </PortalProvider>;
}